import React from 'react'

export type VenueContext = {
  mobile: Nullable<boolean>
  appView: boolean
}

export const CONTEXT_DEFAULT: VenueContext = { mobile: true, appView: false }

const ThemeContext = React.createContext<VenueContext>(CONTEXT_DEFAULT)

export default ThemeContext
